export const canadaOverseasProducts = [
  {
    id: "cowp1",
    name: "Maple Wood Cutting Board Set — 3 Sizes",
    category: "Kitchen & Home",
    price: 54.99,
    originalPrice: 89.99,
    commission: 1.10,
    image: "https://public.readdy.ai/ai/img_res/7e4ab546fc33254baca9bbfb247716be.jpg",
    supplier: "NorthCraft Canada Warehouse",
    supplierFlag: "🇨🇦",
    location: "Toronto, ON",
    stock: 210,
    sold: 1180,
    rating: 4.9,
    reviews: 287,
    shipsIn: "1-3 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "Solid maple hardwood. Food-safe oil finish. Sizes: 8x10, 10x14, 12x18 inches. Juice groove on large board.",
  },
  {
    id: "cowp2",
    name: "Winter Parka Jacket — Waterproof -30°C Rated",
    category: "Clothing & Apparel",
    price: 119.99,
    originalPrice: 199.99,
    commission: 2.40,
    image: "https://readdy.ai/api/search-image?query=premium%20winter%20parka%20jacket%20waterproof%20insulated%20navy%20blue%20color%20on%20white%20background%2C%20Canadian%20winter%20coat%20with%20fur%20hood%2C%20professional%20apparel%20product%20photography%20with%20clean%20studio%20lighting&width=400&height=300&seq=cowp2&orientation=landscape",
    supplier: "ArcticWear Warehouse",
    supplierFlag: "🇨🇦",
    location: "Vancouver, BC",
    stock: 145,
    sold: 892,
    rating: 4.8,
    reviews: 214,
    shipsIn: "2-4 days",
    badge: "Top Rated",
    badgeColor: "bg-[#D4AF37]",
    description: "Rated to -30°C. 100% waterproof shell. Removable faux-fur hood. 4 interior pockets. Available S-3XL.",
  },
  {
    id: "cowp3",
    name: "Organic Maple Syrup Gift Set — 4 Varieties",
    category: "Food & Gourmet",
    price: 39.99,
    originalPrice: 64.99,
    commission: 0.80,
    image: "https://readdy.ai/api/search-image?query=organic%20maple%20syrup%20gift%20set%20four%20glass%20bottles%20different%20grades%20amber%20dark%20golden%20on%20white%20background%2C%20Canadian%20gourmet%20food%20product%20photography%20with%20warm%20natural%20lighting&width=400&height=300&seq=cowp3&orientation=landscape",
    supplier: "PureMaple Warehouse",
    supplierFlag: "🇨🇦",
    location: "Montreal, QC",
    stock: 380,
    sold: 2640,
    rating: 4.9,
    reviews: 631,
    shipsIn: "1-2 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "100% pure Canadian maple syrup. Grades: Golden, Amber, Dark, Very Dark. 250ml each. Gift box included.",
  },
  {
    id: "cowp4",
    name: "Smart Air Purifier HEPA H13 — 800 sq ft",
    category: "Electronics",
    price: 94.99,
    originalPrice: 149.99,
    commission: 1.90,
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20air%20purifier%20white%20cylindrical%20design%20on%20white%20background%2C%20HEPA%20filter%20home%20appliance%2C%20minimalist%20product%20photography%20with%20clean%20studio%20lighting%20and%20soft%20shadows&width=400&height=300&seq=cowp4&orientation=landscape",
    supplier: "CleanAir Canada Warehouse",
    supplierFlag: "🇨🇦",
    location: "Calgary, AB",
    stock: 178,
    sold: 1340,
    rating: 4.7,
    reviews: 398,
    shipsIn: "1-3 days",
    badge: "Hot Deal",
    badgeColor: "bg-orange-500",
    description: "True HEPA H13 filter. Covers 800 sq ft. WiFi + app control. Auto mode. PM2.5 sensor. Ultra-quiet 22dB.",
  },
  {
    id: "cowp5",
    name: "Cedar Sauna Kit — 2-Person Indoor",
    category: "Health & Wellness",
    price: 899.99,
    originalPrice: 1299.99,
    commission: 18.00,
    image: "https://readdy.ai/api/search-image?query=indoor%20cedar%20wood%20sauna%20kit%20two%20person%20home%20sauna%20on%20white%20background%2C%20natural%20wood%20panels%20and%20glass%20door%2C%20luxury%20wellness%20product%20photography%20with%20warm%20lighting&width=400&height=300&seq=cowp5&orientation=landscape",
    supplier: "NordicSauna Warehouse",
    supplierFlag: "🇨🇦",
    location: "Edmonton, AB",
    stock: 22,
    sold: 148,
    rating: 4.9,
    reviews: 67,
    shipsIn: "3-5 days",
    badge: "Premium",
    badgeColor: "bg-[#D4AF37]",
    description: "Canadian western red cedar. 4kW heater included. Tempered glass door. Easy assembly. 2-year warranty.",
  },
  {
    id: "cowp6",
    name: "Merino Wool Blanket — Extra Large 60x80\"",
    category: "Home & Bedding",
    price: 74.99,
    originalPrice: 119.99,
    commission: 1.50,
    image: "https://readdy.ai/api/search-image?query=luxury%20merino%20wool%20blanket%20extra%20large%20folded%20neatly%20in%20cream%20and%20grey%20colors%20on%20white%20background%2C%20soft%20texture%20visible%2C%20premium%20home%20textile%20product%20photography%20with%20natural%20lighting&width=400&height=300&seq=cowp6&orientation=landscape",
    supplier: "WoolCraft Warehouse",
    supplierFlag: "🇨🇦",
    location: "Ottawa, ON",
    stock: 290,
    sold: 1760,
    rating: 4.8,
    reviews: 423,
    shipsIn: "1-2 days",
    badge: "Top Rated",
    badgeColor: "bg-[#D4AF37]",
    description: "100% pure merino wool. 60x80 inches. Machine washable. Hypoallergenic. Available in 6 colors.",
  },
  {
    id: "cowp7",
    name: "Vitamin D3 + K2 Supplement — 365 Capsules",
    category: "Health & Wellness",
    price: 29.99,
    originalPrice: 49.99,
    commission: 0.60,
    image: "https://readdy.ai/api/search-image?query=vitamin%20D3%20K2%20supplement%20bottle%20365%20capsules%20on%20white%20background%2C%20health%20supplement%20product%20photography%2C%20clean%20minimal%20design%20with%20soft%20studio%20lighting&width=400&height=300&seq=cowp7&orientation=landscape",
    supplier: "NorthHealth Warehouse",
    supplierFlag: "🇨🇦",
    location: "Toronto, ON",
    stock: 520,
    sold: 3890,
    rating: 4.9,
    reviews: 912,
    shipsIn: "1-2 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "5000 IU Vitamin D3 + 100mcg K2 MK-7. Non-GMO. Gluten-free. Health Canada approved. 1-year supply.",
  },
  {
    id: "cowp8",
    name: "Portable Espresso Maker — Manual Pump",
    category: "Kitchen & Home",
    price: 44.99,
    originalPrice: 69.99,
    commission: 0.90,
    image: "https://readdy.ai/api/search-image?query=portable%20manual%20espresso%20maker%20compact%20silver%20and%20black%20design%20on%20white%20background%2C%20travel%20coffee%20maker%20product%20photography%2C%20clean%20minimal%20aesthetic%20with%20soft%20studio%20lighting&width=400&height=300&seq=cowp8&orientation=landscape",
    supplier: "BrewNorth Warehouse",
    supplierFlag: "🇨🇦",
    location: "Vancouver, BC",
    stock: 340,
    sold: 2210,
    rating: 4.7,
    reviews: 534,
    shipsIn: "1-3 days",
    badge: "Hot Deal",
    badgeColor: "bg-orange-500",
    description: "18-bar manual pump. Compatible with Nespresso pods & ground coffee. BPA-free. Includes travel case.",
  },
];

export const canadaOverseasCategories = [
  "All Products",
  "Electronics",
  "Kitchen & Home",
  "Clothing & Apparel",
  "Food & Gourmet",
  "Health & Wellness",
  "Home & Bedding",
];

export const canadaWarehouseLocations = [
  { city: "Toronto", province: "ON", products: 11200 },
  { city: "Vancouver", province: "BC", products: 8900 },
  { city: "Montreal", province: "QC", products: 7400 },
  { city: "Calgary", province: "AB", products: 5600 },
  { city: "Ottawa", province: "ON", products: 4300 },
  { city: "Edmonton", province: "AB", products: 3800 },
];
